import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import CustomerLayout from './CustomerLayout';

const ProtectedRoute = ({ children }) => {
    const { isAuthenticated, loading } = useAuth();

    if (loading) {
        return (
            <div className="min-vh-100 d-flex align-items-center justify-content-center">
                <div className="text-center">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="mt-3">Loading...</p>
                </div>
            </div>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/customer/login" replace />;
    }

    return <CustomerLayout>{children}</CustomerLayout>;
};

export default ProtectedRoute;

